<!--
/*******************************************************************************
*@ 컴포넌트명   : Product11-01-003-000012ogmmr.vue
*@ 컴포넌트설명 :[미얀마] 예금 상품 > 예금 상품 상세(당좌예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!-- 한국어 -->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>당좌예금</h2>
          </div>
          <div class="description">
            <p>
              당좌결제용 입출금이 자유로운 통장
            </p>
          </div>
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">

              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품개요</dt>
            <dd>당좌결제용 입출금이 자유로운 통장</dd>
            <dt>가입대상</dt>
            <dd>미얀마 국민, 외국인거주자</dd>
            <dt>신규가능통화</dt>
            <dd>MMK , USD</dd>
            <dt>계좌개설 최소금액</dt>
            <dd>MMK 100,000<br>
                USD 100</dd>
            <dt>최소유지금액</dt>
            <dd>MMK 100,000<br>
                USD 100</dd>
            <dt>수수료금액</dt>
            <dd>입금수수료(USD A/C) : 입금금액의 0.03%, 출금수수료(USD A/C) : 출금금액의 0.5%</dd>
            <dt>가입방법</dt>
            <dd>영업점가입</dd>
          </dl>

          <div class="info info-type4">
              <strong>Required documents for application</strong>
          </div>

          <div class="info info-type4">
              <strong>Individual</strong>
              <p>(1) National Registration Card (or) Passport (Visa should be valid)</p>
              <p>(2) Source of Fund (For USD currency)</p>
            
            </div>
            <div class="info info-type4">
              <strong>Company</strong>
              <p>(1) Company Extract from DICA</p>
              <p>(2) Company Registration from DICA</p>
              <p>(3) MIC Permit (if relevant)</p>
              <p>(4) Board of Director Resolution (or) Power of Attorney</p>
              <p>(5) Cover Letter with Company Letter Head for applying bank account(s)</p>
              <p>(6) Copy of NRCs (or) Copy of Passports (valid Business visa for each signatory) of director and Authorize signatory lists</p>
              <p>(7) Shareholder lists</p>
              <p>(8) Partnership Agreement (if relevant)</p>
            </div>
            <div class="info info-type4">
              <strong>Branch/ Representative Office</strong>
              <p>(1) Company Registration from DICA</p>
              <p>(2) Company Extract from DICA</p>
              <p>(3) Parent Registration Certificate (if relevant)</p>
              <p>(4) Power of Attorney (or) Consent and Certificate of Director</p>
              <p>(5) Copy of NRCs (or) Copy of Passports (valid visa for each signatory) of director lists</p>
              <p>(6) Cover Letter with Company Letter Head for applying bank account(s)</p>
              <p>(7) Shareholder lists</p>
            </div>
            <div class="info info-type4">
              <strong>Local NGO/ International NGO</strong>
              <p>(1) Organization Registration Certificate</p>
              <p>(2) Constitution of NGO</p>
              <p>(3) Brief of each committee members (Name and Address of senior management and identification documents)</p>
              <p>(4) Committee meeting minutes regarding opening of accounts</p>
              <p>(5) Authorized persons’ National Registration Card or Passport (valid visa) for each signatory) of organization persons</p>
            </div>
            <div class="info info-type4">
              <strong>Association, charities, club/ societies and religious organizations</strong>
              <p>(1) Certificate of registration relative Government</p>
              <p>(2) Constitution of entity</p>
              <p>(3) Committee meeting minutes regarding opening of accounts</p>
              <p>(4) Authorized persons’ National Registration Card or Passport (valid business visa for each signatory) of organization persons</p>
              <p>(5) Cover Letter with Company Letter Head for applying bank account(s)</p>
            </div>
        </article>
      </div>
    </template>
    <!-- 영어 -->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Current Deposit</h2>
          </div>
          <div class="description">
            <p>
              Current deposit is a non-interest bearing account suitable for customers who need to receive and make payments frequently by using cheque
            </p>
          </div>
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">

              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>About the products</dt>
            <dd>Current deposit is a non-interest bearing account suitable for customers who need to receive and make payments frequently by using cheque</dd>
            <dt>Eligibility</dt>
            <dd>Myanmar National and Resident Foreigner</dd>
            <dt>Available currency</dt>
            <dd>MMK , USD</dd>
            <dt>Initial Amount</dt>
            <dd>MMK 100,000<br>
                USD 100</dd>
            <dt>Minimum Amount</dt>
            <dd>MMK 100,000<br>
                USD 100</dd>
            <dt>Fees</dt>
            <dd>Deposit and withdraw fee will be charged for forgein currency account (0.03% and 0.5%)</dd>
            <dt>How to apply</dt>
            <dd>Visit KB branch</dd>
          </dl>

          <div class="info info-type4">
              <strong>Required documents for application</strong>
          </div>

          <div class="info info-type4">
              <strong>Individual</strong>
              <p>(1) National Registration Card (or) Passport (Visa should be valid)</p>
              <p>(2) Source of Fund (For USD currency)</p>
            
            </div>
            <div class="info info-type4">
              <strong>Company</strong>
              <p>(1) Company Extract from DICA</p>
              <p>(2) Company Registration from DICA</p>
              <p>(3) MIC Permit (if relevant)</p>
              <p>(4) Board of Director Resolution (or) Power of Attorney</p>
              <p>(5) Cover Letter with Company Letter Head for applying bank account(s)</p>
              <p>(6) Copy of NRCs (or) Copy of Passports (valid Business visa for each signatory) of director and Authorize signatory lists</p>
              <p>(7) Shareholder lists</p>
              <p>(8) Partnership Agreement (if relevant)</p>
            </div>
            <div class="info info-type4">
              <strong>Branch/ Representative Office</strong>
              <p>(1) Company Registration from DICA</p>
              <p>(2) Company Extract from DICA</p>
              <p>(3) Parent Registration Certificate (if relevant)</p>
              <p>(4) Power of Attorney (or) Consent and Certificate of Director</p>
              <p>(5) Copy of NRCs (or) Copy of Passports (valid visa for each signatory) of director lists</p>
              <p>(6) Cover Letter with Company Letter Head for applying bank account(s)</p>
              <p>(7) Shareholder lists</p>
            </div>
            <div class="info info-type4">
              <strong>Local NGO/ International NGO</strong>
              <p>(1) Organization Registration Certificate</p>
              <p>(2) Constitution of NGO</p>
              <p>(3) Brief of each committee members (Name and Address of senior management and identification documents)</p>
              <p>(4) Committee meeting minutes regarding opening of accounts</p>
              <p>(5) Authorized persons’ National Registration Card or Passport (valid visa) for each signatory) of organization persons</p>
            </div>
            <div class="info info-type4">
              <strong>Association, charities, club/ societies and religious organizations</strong>
              <p>(1) Certificate of registration relative Government</p>
              <p>(2) Constitution of entity</p>
              <p>(3) Committee meeting minutes regarding opening of accounts</p>
              <p>(4) Authorized persons’ National Registration Card or Passport (valid business visa for each signatory) of organization persons</p>
              <p>(5) Cover Letter with Company Letter Head for applying bank account(s)</p>
            </div>
        </article>
      </div>
    </template>
    
     <!-- 미얀마 -->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>စာရင်းရှင်အပ်ငွေစာရင်း</h2>
          </div>
          <div class="description">
            <p>
              စာရင်းရှင်အပ်ငွေတွင် အတိုးရရှိမည်မဟုတ်ဘဲ စာရင်းပိုင်ရှင်သည် ချက်လက်မှတ်ကို အသုံးပြု၍ ငွေပေးချေမှုအား ပြုလုပ် နိုင်ပါသည်။
            </p>
          </div>
          <!-- 금리 이율-->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">

              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>ထုတ်ကုန်အကြောင်း</dt>
            <dd>စာရင်းရှင်အပ်ငွေတွင် အတိုးရရှိမည်မဟုတ်ဘဲ စာရင်းပိုင်ရှင်သည် ချက်လက်မှတ်ကို အသုံးပြု၍ ငွေပေးချေမှုအား ပြုလုပ် နိုင်ပါသည်။</dd>
            <dt>စာရင်းဖွင့်နိုင်သူ</dt>
            <dd>မြန်မာနိုင်ငံသားနှင့် မြန်မာနိုင်ငံအတွင်းနေထိုင်သူနိုင်ငံခြားသား</dd>
            <dt>ငွေကြေးအမျိုးအစား</dt>
            <dd>မြန်မာကျပ်၊ ဒေါ်လာ</dd>
            <dt>ကနဉီးအပ်ငွေ</dt>
            <dd>ကျပ် ၁၀၀,၀၀၀ ၊ ဒေါ်လာ ၁၀၀
            <dt>အနည်းဆုံးပမာဏ</dt>
            <dd>ကျပ် ၁၀၀,၀၀၀ ၊ ဒေါ်လာ ၁၀၀</dd>
            <dt>အခကြေးငွေ</dt>
            <dd>နိုင်ငံခြားအပ်ငွေအတွက် ၀.၀၃% နှင့် ထုတ်ငွေအတွက် ၀.၀၅%</dd>
            <dt>လျှောက်ထားနည်း</dt>
            <dd>ဘဏ်ခွဲမှာလျှောက်ထားပါ</dd>
          </dl>

          <div class="info info-type4">
              <strong>လျှောက်လွှာများအတွက်လိုအပ်သောစာရွက်စာတမ်းများ</strong>
          </div>

          <div class="info info-type4">
              <strong>တစ်ဦးချင်း</strong>
              <p>(1) မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် (သက်တမ်းရှိဗီဇာ)</p>
              <p>(2) ဝင်ငွေရရှိမှုအထောက်အထား (USD currency စာရင်းဖွင့်လျှင်)</p>
            
            </div>
            <div class="info info-type4">
              <strong>ကုမ္ပဏီ</strong>
              <p>(1) DICA မှ Company Extract</p>
              <p>(2) DICA မှ ကုမ္ပဏီမှတ်ပုံတင်လက်မှတ်</p>
              <p>(3) MIC Permit (if relevant)</p>
              <p>(4) ဒါရိုက်တာအဖွဲ့၏ဆုံးဖြတ်မှုအစည်းအဝေးမှတ်တမ်း (သို့မဟုတ်) ကိုယ်စားလှယ်လွှဲစာ</p>
              <p>(5) ဘဏ်စာရင်း(များ)ဖွင့်ရန်တင်ပြထားသော ကုမ္ပဏီ Letter Head ပါစာ</p>
              <p>(6) ဒါရိုက်တာနှင့် ဘဏ်စာရင်းလက်မှတ်ထိုးခွင့်ရှိသူများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)</p>
              <p>(7) ရှယ်ယာရှင်စာရင်း</p>
              <p>(8) မိတ်ဖက်သဘောတူညီချက် (လိုအပ်လျှင်)</p>
            </div>
            <div class="info info-type4">
              <strong>ဘဏ်ခွဲ/ ကိုယ်စားလှယ်ရုံး</strong>
              <p>(1) DICA မှ Company Extract</p>
              <p>(2) DICA မှ ကုမ္ပဏီမှတ်ပုံတင်လက်မှတ်</p>
              <p>(3) ရုံးချူပ်မှတ်ပုံတင်လက်မှတ် (လိုအပ်လျှင်)</p>
              <p>(4) ကိုယ်စားလှယ်လွှဲစာ (သို့မဟုတ်) ဒါရိုက်တာသဘောတူညီချက်လက်မှတ်</p>
              <p>(5) စာရင်းရှိ ဒါရိုက်တာများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)</p>
              <p>(6) ဘဏ်စာရင်း(များ)ဖွင့်ရန်တင်ပြထားသော ကုမ္ပဏီ Letter Head ပါစာ</p>
              <p>(7) ရှယ်ယာရှင်စာရင်း</p>
            </div>
            <div class="info info-type4">
              <strong>ပြည်တွင်း NGO/ နိုင်ငံတကာ NGO</strong>
              <p>(1) အဖွဲ့အစည်းမှတ်ပုံတင်လက်မှတ်</p>
              <p>(2) NGO သင်းဖွဲ့စည်းမျဥ်း</p>
              <p>(3) အသင်းဝင်တစ်ဦးချင်းစီ၏ကိုယ်ရေးအကျဥ်း (Senior Management များ၏ အမည်၊ လိပ်စာနှင့် မှတ်ပုံတင်စာရွက်စာတမ်းများ)</p>
              <p>(4) အဖွဲ့အစည်း၏ ဘဏ်စာရင်းများဖွင့်ရန်ဆုံးဖြတ်မှုအစည်းအဝေးမှတ်တမ်း</p>
              <p>(5) အဖွဲ့အစည်းဘဏ်စာရင်းလက်မှတ်ထိုးခွင့်ရှိသူများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)</p>
            </div>
            <div class="info info-type4">
              <strong>လူမှုကူညီရေးနှင့် ဘာသာ‌ရေးအသင်းအဖွဲ့များ</strong>
              <p>(1) သက်ဆိုင်ရာဝန်ကြီးဌာနမှတ်ပုံတင်လက်မှတ်</p>
              <p>(2) သင်းဖွဲ့စည်းမျဥ်း</p>
              <p>(3) အဖွဲ့အစည်း၏ ဘဏ်စာရင်းများဖွင့်ရန်ဆုံးဖြတ်မှုအစည်းအဝေးမှတ်တမ်း</p>
              <p>(4) အဖွဲ့အစည်းဘဏ်စာရင်းလက်မှတ်ထိုးခွင့်ရှိသူများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)</p>
              <p>(5) ဘဏ်စာရင်း(များ)ဖွင့်ရန်တင်ပြထားသော ကုမ္ပဏီ Letter Head ပါစာ</p>
            </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed:{
    ...mapFields(["lang"]),
  }
};
</script>

